import React from 'react';
import {
  useLocation,
  useNavigate,
} from 'react-router-dom';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Person2RoundedIcon from '@mui/icons-material/Person2Rounded';
import {
  FaxIcon,
} from 'core/icons';

const iconClassName = '!w-4 !h-4';
const tabClassName = '!p-2 !min-h-[48px] !normal-case !font-semibold';

const tabs = [{
  Icon: FaxIcon,
  value: '/fax',
  label: 'Fax',
}, {
  Icon: Person2RoundedIcon,
  value: '/fax/contacts',
  label: 'Contacts',
}];

export default function Navigation() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <Tabs
      className="!min-h-[48px] w-full border-b border-b-gray-200 px-4 populate-route-tabs"
      value={location.pathname}
      onChange={(event, value: string) => {
        navigate(value);
      }}
    >
      {tabs.map(({ Icon, ...tabOptions }) => (
        <Tab
          key={tabOptions.value}
          className={tabClassName}
          iconPosition="start"
          {...tabOptions}
          icon={<Icon className={iconClassName} />}
        />
      ))}
    </Tabs>
  );
}
